<template>
  <div class="container-fluid">
    <div class="mt-4">
      <Breadcrumb :breadcrumbs="breadcrumbs"/>

      <router-view v-if="isEnabled && $withPolicy('cm-frotas', 'viewer')"/>

      <div v-else>
        <h1>Aplicativo não habilitado</h1>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Breadcrumb from '@/components/shares/Breadcrumb'
  import GetAccountApps from '@/mixins/GetAccountApps'

  export default {
    components: { Breadcrumb },
    computed: {
      isEnabled() {
        return this.activeAccountApps.some(aa => aa.name === 'cm-frotas')
      }
    },
    mixins: [BreadcrumbMixin, GetAccountApps],
    name: 'cm-frotas'
  }
</script>

<style scoped>

</style>
